// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_rating_votes.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_rating_votes',
	field: function() { return 'g.game_rating_count' }
})
